import { render, staticRenderFns } from "./CodingList.vue?vue&type=template&id=58842619&"
import script from "./CodingList.vue?vue&type=script&lang=js&"
export * from "./CodingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports